<template>
  <iframe id="frame" frameborder="0"></iframe>
</template>
<script>
export default {
  name: "Live",
  data() {
    return {
      course_id: this.$route.query.course_id,
      period_id: this.$route.query.period_id,
      bjy_period_id: this.$route.query.bjy_period_id,
      type: this.$route.query.type,
      last_time: 0,
    };
  },
  methods: {
    handle(url) {
      document.getElementById("frame").src = url;
    },
    async onMessgae(event) {
      if (!event.data.totalTime || !this.bjy_period_id) {
        return;
      }
      if (this.last_time == event.data.currentTime) {
        return;
      }
      this.last_time = event.data.currentTime;
      let formData = new FormData();
      formData.append('course_basis_id',parseInt(this.course_id));
      formData.append('course_periods_id',parseInt(this.bjy_period_id));
      formData.append('total_time',parseInt(event.data.totalTime));
      formData.append('last_time',parseInt(event.data.currentTime));
      formData.append('current_time',120);
      await this.$http.post("/api/app/course/playBack", formData,{
        contentType:'multipart/form-data'
      });
    },
    async play() {
      let course_type = this.$route.query.course_type;

      let liveData;
      if (course_type == 1) {
        liveData = await this.$http.get(
          "/api/app/oto/getLiveRoomCode/" + this.course_id + "/0",
          {},
          {
            onError: () => {
              this.$router.push({ name: "Home" });
            },
          },
        );
      } else if (
        course_type == 2 ||
        course_type == 3 ||
        course_type == 4 ||
        course_type == 15 ||
        course_type == 16
      ) {
        let data = await this.$http.get(
          "/api/app/getPcRoomCode/course_id=" +
            this.course_id +
            "/chapter_id=" +
            this.period_id,
          {
            type: this.type,
            arrange_id: this.$route.query.arrange_id,
          },
          {
            onError: () => {
              this.$router.push({ name: "Home" });
            },
          },
        );
        liveData = data.chapterInfo;
      } else {
        return;
      }
      let frame = document.getElementById("frame");
      frame.allow = "microphone;camera;midi;encrypted-media;";
      document.getElementById("frame").src = liveData.web_url;
    },
  },
  mounted() {
    if (this.bjy_period_id) {
      window.addEventListener("message", this.onMessgae);
    }
    this.$nextTick(async () => {
      this.play();
    });
  },
  beforeDestroy() {
    if (this.bjy_period_id) {
      window.removeEventListener("message", this.onMessgae);
    }
  },
};
</script>
<style lang="scss" scoped>
iframe {
  width: 100%;
  height: 100vh;
  display: block;
}
</style>
